<template>
    <div class="mobile-preview-wrapper">
        <div class="phone-frame">
            <!-- Phone Notch/Speaker (Visual only) -->
            <div class="phone-notch"></div>
            
            <div class="screen-content custom-scrollbar">
                <div class="header-top-nav">
                    <div class="top-background">
                        <svg class="top-background-svg" viewBox="0 0 330 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <ellipse cx="111" cy="-84" rx="219" ry="139" fill="var(--primary-color, #F93E3E)"/>
                        </svg>
                    </div>
                    <div class="avatar-wrapper">
                        <img :src="defaultLogo" alt="Avatar" class="avatar-img">
                    </div>
                </div>

                <div class="back-nav-mock">
                    <i class="fas fa-arrow-left me-2"></i> Back to Dashboard
                </div>

                <div class="newsletter-detail-container" v-if="newsletter.title || newsletter.body">
                    <main class="main-content">
                        <h1 class="page-title">{{ newsletter.title || 'Newsletter Title' }}</h1>
                        <p class="page-subtitle">{{ newsletter.summary || 'Short summary of the newsletter content will appear here.' }}</p>
                        
                        <div class="hero-image">
                            <img :src="newsletter.cover_image || defaultLogo" alt="Hero Image">
                        </div>
                        
                        <div class="meta-row">
                            <div class="meta-group">
                                <span class="meta-item"><i class="far fa-calendar me-2"></i> {{ formatDate(newsletter.published_at || newsletter.created_at) }}</span>
                                <span class="meta-item">
                                    <i class="fas fa-building me-2"></i>
                                    Your Corporate/Branch/Merchant
                                </span>
                            </div>
                        </div>
                        
                        <div class="article-body">
                             <!-- Render HTML content safely -->
                             <div v-html="newsletter.body || '<p>Newsletter body content will be displayed here. You can use the editor to add text, images, and formatting.</p>'"></div>
                        </div>
                    </main>
                </div>

                <div v-else class="empty-detail-state">
                    <div class="empty-placeholder">
                        <i class="fas fa-newspaper fa-3x mb-3 opacity-20"></i>
                        <p>Start writing to see the preview</p>
                    </div>
                </div>
            </div>

            <!-- Bottom Nav (Visual) -->
            <div class="bottom-nav">
                <div class="nav-indicator"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'NewsletterPreview',
    props: {
        newsletter: {
            type: Object,
            default: () => ({
                title: '',
                summary: '',
                body: '',
                cover_image: null,
                created_at: new Date().toISOString(),
                published_at: null
            })
        }
    },
    setup() {
        const defaultLogo = computed(() => {
            return window.localStorage?.getItem('corporateLogo') || '/img/member-icon/tier-logo.svg'
        })

        return {
            defaultLogo
        }
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return 'Not Published'
            const date = new Date(dateStr)
            return date.toLocaleDateString('en-US', { 
                month: 'short', 
                day: 'numeric',
                year: 'numeric'
            })
        },
        truncate(text, length = 25) {
            if (!text) return ''
            if (text.length <= length) return text
            return text.substring(0, length) + '..'
        }
    }
}
</script>

<style scoped>
.mobile-preview-wrapper {
    display: flex;
    justify-content: center;
    padding: 20px 0;
}

.phone-frame {
    width: 375px;
    height: 750px;
    background: #F8F9FA;
    border: 12px solid #1F2937;
    border-radius: 40px;
    position: relative;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    transform: scale(0.85);
    transform-origin: top center;
}

.phone-notch {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 150px;
    height: 28px;
    background: #1F2937;
    border-bottom-left-radius: 18px;
    border-bottom-right-radius: 18px;
    z-index: 100;
}

.screen-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    background: #EEF3F3;
    padding-bottom: 40px;
    position: relative;
}

.header-top-nav {
    position: relative;
    height: 40px;
    z-index: 20;
}

.avatar-wrapper {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 30;
}

.avatar-img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 2px solid white;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    object-fit: cover;
}

.top-background {
    position: absolute;
    top: -5px;
    left: -5px;
    width: 110%;
    z-index: 1;
}

.top-background img,
.top-background svg {
    width: 100%;
}

.back-nav-mock {
    position: relative;
    z-index: 10;
    margin-top: 64px;
    margin-left: 20px;
    color: #6b7280;
    font-size: 14px;
    margin-bottom: 20px;
}

/* Custom Scrollbar */
.custom-scrollbar::-webkit-scrollbar {
    width: 4px;
}
.custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #D1D5DB;
    border-radius: 2px;
}

.newsletter-detail-container {
    position: relative;
    z-index: 10;
    padding: 0 15px;
}

.main-content {
    background: white;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.page-title {
    font-size: 20px;
    font-weight: 600;
    color: #111827;
    margin-top: 0;
    margin-bottom: 8px;
    overflow-wrap: break-word;
    word-break: break-word;
}

.page-subtitle {
    font-size: 13px;
    color: #6B7280;
    margin-bottom: 16px;
    overflow-wrap: break-word;
    word-break: break-word;
}

.hero-image {
    width: 100%;
    height: 180px;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 16px;
    background-color: #f3f4f6;
}

.hero-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.meta-row {
    border-bottom: 1px solid #e5e7eb;
    padding-bottom: 16px;
    margin-bottom: 16px;
}

.meta-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #6b7280;
    font-size: 13px;
}

.article-body {
    font-size: 14px;
    line-height: 1.6;
    color: #374151;
    overflow-wrap: break-word;
    word-break: break-word;
}

.article-body :deep(img) {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
}

.article-body :deep(p) {
    margin-bottom: 1rem;
}

.article-body :deep(ul),
.article-body :deep(ol) {
    margin-bottom: 1rem;
    padding-left: 2rem;
}

.article-body :deep(h1),
.article-body :deep(h2),
.article-body :deep(h3),
.article-body :deep(h4),
.article-body :deep(h5),
.article-body :deep(h6) {
    margin-top: 1.5rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.article-body :deep(h1:first-child),
.article-body :deep(h2:first-child),
.article-body :deep(h3:first-child),
.article-body :deep(p:first-child) {
    margin-top: 0;
}

.article-body :deep(a) {
    color: var(--primary-color, #0d6efd);
    text-decoration: none;
}

.article-body :deep(a:hover) {
    text-decoration: underline;
}

.article-body :deep(blockquote) {
    border-left: 3px solid #d1d5db;
    padding-left: 1rem;
    margin-left: 0;
    margin-right: 0;
    color: #4b5563;
    font-style: italic;
    margin-bottom: 1rem;
}

.empty-detail-state {
    padding: 100px 20px;
    text-align: center;
}

.empty-placeholder {
    color: #9CA3AF;
}

.empty-placeholder p {
    margin-top: 10px;
    font-size: 14px;
}

.bottom-nav {
    height: 24px;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #E5E7EB;
    flex-shrink: 0;
}

.nav-indicator {
    width: 100px;
    height: 4px;
    background: #E5E7EB;
    border-radius: 2px;
}
</style>